/**
 * Cicha Pewność w palecie marki klienta - powtarzalne bloki treści są czytelne, spokojne i kierują do konkretnego, spokojnego spotkania w najbliższym biurze.
 */
import React from "react";
import { ArrowRight, Check, ChevronDown, MapPin } from "lucide-react";
import { Link } from "wouter";
import {
  faqItems,
  offices,
  physicalOffices,
  processSteps,
  servicedCities,
} from "@/lib/site-data";

export function FaqList({ limit }: { limit?: number }) {
  return (
    <div className="faq-list">
      {faqItems.slice(0, limit ?? faqItems.length).map((item, index) => (
        <details className="faq-item" key={item.question}>
          <summary>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <strong>{item.question}</strong>
            <ChevronDown size={20} />
          </summary>
          <p>{item.answer}</p>
        </details>
      ))}
    </div>
  );
}

export function ProcessList({ short = false }: { short?: boolean }) {
  const items = short ? processSteps.slice(0, 4) : processSteps;
  return (
    <ol className="process-list">
      {items.map(step => (
        <li key={step.number}>
          <div className="step-number">{step.number}</div>
          <div>
            <div className="step-heading">
              <h3>{step.title}</h3>
              <span>{step.time}</span>
            </div>
            <p>{step.text}</p>
            <div className="client-does">
              <Check size={16} />
              <span>
                <strong>Ty:</strong> {step.client}
              </span>
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}

export function OfficeGrid() {
  return (
    <div className="office-grid">
      {physicalOffices.map(office => (
        <article key={office.city} className="office-card">
          <MapPin size={22} />
          <div>
            <h3>{office.city}</h3>
            <p>{office.address}</p>
            <span>{office.detail}</span>
            <Link href={`/upadlosc-konsumencka-${office.slug}`}>
              Poznaj kancelarię <ArrowRight size={15} />
            </Link>
          </div>
        </article>
      ))}
    </div>
  );
}

export function CityCoverageGrid() {
  return (
    <>
      <nav
        className="city-coverage-directory"
        aria-label="Miasta obsługiwane zdalnie"
      >
        <p>Wybierz miasto obsługiwane zdalnie:</p>
        <div className="city-link-cloud">
          {servicedCities.map(office => (
            <Link
              key={office.slug}
              href={`/upadlosc-konsumencka-${office.slug}`}
            >
              {office.city}
            </Link>
          ))}
        </div>
      </nav>
      <div className="city-coverage-grid">
        {servicedCities.map(office => (
          <article key={office.slug}>
            <MapPin size={18} />
            <div>
              <h3>Upadłość konsumencka {office.city}</h3>
              <p>{office.detail}</p>
              <Link href={`/upadlosc-konsumencka-${office.slug}`}>
                Sprawdź formy rozmowy <ArrowRight size={14} />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </>
  );
}
